/* eslint-disable no-bitwise */
export enum DimensionsAccess {
    NoAccess = 1,
    HasDimension = 2,
    HasAdvancedPackage = 4,

    /** For Multiple dimensions, the Dimension module and the Advanced package are required */
    HasMultiDimensions = HasDimension | HasAdvancedPackage,
}

export interface Dimension {
    id: number;
    name: string;
    active: boolean;
    lines: DimensionLine[];
}

export type DimensionLine = DimensionValue | DistributionKey;

export enum DimensionLineType {
    DimensionValue = 'DimensionValue',
    DistributionKey = 'DimensionDistribution',
}

export interface DimensionValue {
    dimensionId: number;
    key: number;
    name: string;
    active: boolean;
    type: DimensionLineType.DimensionValue;
}

export interface DistributionKey {
    dimensionId: number;
    key: number;
    name: string;
    active: boolean;
    distributions: Partial<DimensionDistributionValue>[];
    type: DimensionLineType.DistributionKey;
}

export interface DimensionDistributionValue {
    dimensionValueKey: number | null;
    percent: number;
}

export function isDistributionKey(dimensionLine: DimensionLine): dimensionLine is DistributionKey {
    return dimensionLine.type === DimensionLineType.DistributionKey;
}

export type DimensionsFilterState = Record<number, { dimensionValueKey: number[] }>;
